import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonLabel,
  IonMenuButton,
  IonPage,
  IonSlide,
  IonSlides,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { logoFacebook, logoInstagram, logoTwitter } from "ionicons/icons";
import { useEffect, useState } from "react";
import { useLocation } from "react-router";
interface IPage {
  title: string;
}

const buttons: {
  label: string;
  href: string;
}[] = [
  {
    label: "Home",
    href: "/home",
  },
  {
    label: "Gallery",
    href: "/gallery",
  },
  {
    label: "Donations",
    href: "/donations",
  },
  {
    label: "Contact",
    href: "/contact",
  },
  {
    label: "Wishlist",
    href: "/wishlist",
  },
];

const Page: React.FC<IPage> = ({ children, title }) => {
  const location = useLocation();
  const [active, setActive] = useState(0);
  useEffect(() => {
    if (location.pathname === "/home") setActive(0);
    else if (location.pathname === "/gallery") setActive(1);
    else if (location.pathname === "/donations") setActive(2);
    else if (location.pathname === "/contact") setActive(3);
    else if (location.pathname === "/wishlist") setActive(4);
  }, [location]);

  return (
    <IonPage>
      <IonHeader translucent>
        <IonToolbar className="">
          <IonButtons className=" ">
            <IonMenuButton className="sm:hidden block" />
          </IonButtons>
          {/* <IonTitle className=" text-slate-600 sm:block hidden">
            {title}
          </IonTitle> */}
        </IonToolbar>

        <IonToolbar className="flex">
          <IonButtons slot="start" className="w-full basis-1/3">
            <IonButton>
              <IonIcon icon={logoInstagram} />
            </IonButton>
            <IonButton>
              <IonIcon icon={logoTwitter} />
            </IonButton>
          </IonButtons>
          <IonTitle className=" text-slate-600 sm:hidden block">
            {title}
          </IonTitle>

          <div className="w-full basis-1/3 place-content-around sm:flex hidden">
            {buttons.map(
              (button, i): JSX.Element => (
                <IonButton
                  fill="clear"
                  className=""
                  key={button.label}
                  href={button.href}
                >
                  <IonLabel className={active === i ? " font-bold" : " text-slate-400"}>
                    {button.label}
                  </IonLabel>
                </IonButton>
              )
            )}
          </div>
          <div className="basis-1/3 w-24"></div>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding" fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle className="text-slate-600 " size="large">
              {title}
            </IonTitle>
          </IonToolbar>
        </IonHeader>
        {children}
      </IonContent>
    </IonPage>
  );
};

export default Page;
